<template>
  <div id="gauges-row" v-if="performance && availablity && quality">
    <div class="row" v-show="description">

      <div v-html="$t(`oeeAnalytics.oeeCharts.descriptions.gauges.${description}`)"></div>
    </div>
    <div class="row">
      <div class="gauge-col col-xl-auto col-lg-4 col-md-6 col-sm-12">
        <div class="label-gauge ">{{ getAvailabilityChartData.datasets[0].data[0] }}%</div>
        <Gauge class="chart-container" style="position: relative; height:200px; width:200px"
               :chartData="getAvailabilityChartData"
               :options="getOptions({description:'availability'})"/>
        <div class="title">{{ $t('oeeAnalytics.oeeCharts.gauges.availability') }}</div>
      </div>
      <div class="col xl-math-icon d-none d-xl-block">
        <div class="math-icon-xl">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="gauge-col col-xl-auto col-lg-4 col-md-6 col-sm-12">
        <div class="label-gauge ">{{ getPerformanceChartData.datasets[0].data[0] }}%</div>
        <Gauge class="chart-container" style="position: relative; height:200px; width:200px"
               :chartData="getPerformanceChartData"
               :options="getOptions({description:'performance'})"/>
        <div class="title">{{ $t('oeeAnalytics.oeeCharts.gauges.performance') }}</div>
      </div>
      <div class="col xl-math-icon d-none d-xl-block">
        <div class="math-icon-xl">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="gauge-col col-xl-auto col-lg-4 col-md-12 col-sm-12">
        <div class="label-gauge">{{ getQualityChartData.datasets[0].data[0] }}%</div>
        <Gauge class="chart-container" style="position: relative; height:200px; width:200px"
               :chartData="getQualityChartData"
               :options="getOptions({description:'quality'})"/>
        <div class="title">{{ $t('oeeAnalytics.oeeCharts.gauges.quality') }}</div>
      </div>
      <div class="col xl-math-icon d-none d-xl-block">
        <div class="math-icon-xl">
          <i class="fas fa-equals"></i>
        </div>
      </div>
      <div class="col-12 d-lg-block d-xl-none">
        <div class="math-icon">
          <i class="fas fa-times"></i>
        </div>
        <div class="line"></div>
      </div>
      <div class="gauge-col col-xl-auto col-lg-12 col-md-12 col-sm-12">
        <div class="label-gauge ">{{ getOEEChartData.datasets[0].data[0] }}%</div>
        <Gauge class="chart-container" style="position: relative; height:200px; width:200px"
               :chartData="getOEEChartData"
               :options="getOptions({description:'oee'})"/>
        <div class="title">{{ $t('oeeAnalytics.oeeCharts.gauges.oee') }}</div>
      </div>
    </div>
  </div>
  <ComponentLoadSpinnerV2 v-else :loading="true"/>
</template>

<script>
import Gauge from "@/components/oeeAnalytics/charts/gauge";
import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import oeeCalculations from "@/mixins/oeeAnalytics/oeeCalculations";
import {mapGetters} from "vuex";
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  name: "OEEGauges",
  props: ['availablity', 'performance','quality'],
  mixins: [oeeCalculations, colours],
  components: {
    Gauge,
    ComponentLoadSpinnerV2
  },
  data() {
    return {
      description: 'oee',
      // quality: 1
    }
  },
  computed: {
    ...mapGetters('oeeAnalytics', ['getDateRange']),
    getAvailabilityChartData() {
      let rangeToUse = _.cloneDeep(this.getDateRange);
      let unitToUse = null;

      if (this.getSelectedDate) {
        rangeToUse.fromDate = moment(this.getSelectedDate).startOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        rangeToUse.toDate = moment(this.getSelectedDate).endOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        unitToUse = _.cloneDeep(this.getUnit);
      }


      const availabilityData = this.getAvailabilityDataPerDateUnit(this.availablity, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);
      let averageAvailability = _.meanBy(availabilityData, 'availability');
      const availabilityToDisplay = _.round(averageAvailability * 100, 0);
      return {
        labels: [],
        datasets: [{
          textInTheMiddle: '',
          data: availabilityToDisplay < 100 ? [availabilityToDisplay, 100 - availabilityToDisplay] : [availabilityToDisplay],
          backgroundColor: [this.getOeeColours('availability'), 'white'],
          borderWidth: 0,
          hoverOffset: 4
        }]
      };
    },
    getPerformanceChartData() {
      const performanceToDisplay = _.round(this.performance.overall.performance * 100, 0);
      return {
        labels: [],
        datasets: [{
          textInTheMiddle: '',
          data: performanceToDisplay < 100 ? [performanceToDisplay, 100-performanceToDisplay] : [ performanceToDisplay ],
          backgroundColor: [this.getOeeColours('performance'), 'white'],
          borderWidth: 0,
          hoverOffset: 4
        }]
      };
    },
    getQualityChartData() {
      let q = this.quality && this.quality.overall.quality ? this.quality.overall.quality : 1
      const qualityToDisplay = _.round(q * 100, 0);
       return {
        labels: [],
        datasets: [{
          data: qualityToDisplay < 100 ? [qualityToDisplay, 100 - qualityToDisplay] : [ qualityToDisplay],
          textInTheMiddle: '',
          backgroundColor: [this.getOeeColours('quality'), 'white'],
          borderWidth: 0,
          hoverOffset: 4
        }]
      };
    },
    getOEEChartData() {
      let q = this.quality && this.quality.overall.quality ? this.quality.overall.quality : 1
      const oee = this.calculateOee(this.availablity.overall.availability, this.performance.overall.performance,q);
      let rangeToUse = _.cloneDeep(this.getDateRange);
      let unitToUse = null;

      if (this.getSelectedDate) {
        rangeToUse.fromDate = moment(this.getSelectedDate).startOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        rangeToUse.toDate = moment(this.getSelectedDate).endOf(this.getUnit === 'week' ? 'isoWeek' : this.getUnit).toDate();
        unitToUse = _.cloneDeep(this.getUnit);
      }

      const oeeData = this.getOeeDataPerDateUnit(this.availablity, this.performance,this.quality, rangeToUse.fromDate, rangeToUse.toDate, unitToUse);
      let averageOee = _.meanBy(oeeData, 'oee');

      const oeeToDisplay = _.round(averageOee * 100, 0);

      return {
        labels: [],
        datasets: [{
          data: [oeeToDisplay, 100 - oeeToDisplay],
          textInTheMiddle: '',
          backgroundColor: [this.getOeeColours('oee'), 'white'],
          hoverOffset: 4
        }]
      };
    },
    getDefaultOptions() {
      const self = this
      return {
        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect: false,// duration of animations when hovering an item
        },
        legend: {
          display: false,
        },

        title: {
          display: true,
          text: 'OEE',
          fontSize: 18,
          fontStyle: 'normal',
          position: 'bottom',
        },
        scales: {},
        tooltips: {
          callbacks: {
            // title: function (tooltip) {
            //   return tooltip[0].label
            // },
            // label: function (tooltipItem) {
            //   return self.formattedColonTime(tooltipItem.value) + 'u'    //tooltipItem.value
            // }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 0
            },
            offset: -50,
          }
        },
        responsive: true,
        maintainAspectRatio: true,
      }
    },
    getChartData() {
      return this.getAvailabilityChartData
    }
  },
  methods: {
    getOptions(options) {
      const self = this
      return {
        ...this.getDefaultOptions,
        tooltips: {
          enabled: false
        },
        title: {
          display: true,
          fontSize: 18,
          fontStyle: 'normal',
          position: 'bottom',
        },
        onClick() {
          self.description = options.description
        },
        // onHover(){
        //    self.description = options.description
        // }
      }
    },
  }
}
</script>

<style lang="scss" scoped>


.chart-container {
  display: inline-block;
  height: calc(100%);
  margin: 0 !important;
}

#gauges-row > div {
  /*max-height: 200px;*/
  /*max-width: 1000px;*/
  text-align: center;
}

.label-gauge {
  position: relative;
  top: calc(50% - 1.3rem);
  font-size: 2rem;
  font-weight: bold;
  z-index: 5;
}

.title {
  position: relative;
  margin-top: -4.5rem;
  display: block;
  font-weight: bold;
  font-size: 2rem;
  white-space: nowrap;
}

.gauge-col {
  text-align: center;

}

.line {
  background: rgb(108, 117, 125);
  height: 2px;
}

.math-icon {
  text-align: right;
  font-size: 3rem;
}

.math-icon-xl {
  text-align: center;
  font-size: 3rem;
}

.xl-math-icon {
  top: 80px
}
</style>